import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

//import CreateProfileDialog from "./CreateProfileDialog";
import Picture from "../Common/Picture";
import CloseIcon from "../Common/CloseIcon";
import CapturedPhoto from "./CapturedPhoto";

import { driver } from "../../constants/common";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = (theme) => ({
  titleBar: {
    marginBottom: "35px",
    fontWeight: "500",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0px 24px",
  },
  block: {
    padding: "10px",
    [theme.breakpoints.up("lg")]: {
      margin: "0px 20px",
    },
  },
  recognitionTitle: {
    color: colors.black87,
    borderBottom: "1px solid " + colors.black23,
    fontWeight: "500",
    marginBottom: "20px",
  },
  btnGroup: {
    margin: "50px 0px 20px 0px",
    textAlign: "center",
    "& button": {
      margin: "0px 10px",
    },
  },
  picture: {
    textAlign: "center",
    height: "120px",
    lineHeight: "120px",
  },
  optionsContainer: {
    paddingTop: "8px",
  },
  option: {
    marginBottom: "5px",
  },
  input: {
    width: "250px",
  },
  viewMore: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  rootIcon: {
    minWidth: "36px",
  },
  insetItem: {
    paddingLeft: "36px",
  },
});

const DetectionDetails = (props) => {
  const { classes, type, lpr, ocr, fr } = props;

  const [licensePlate, setLicensePlate] = React.useState("");
  const [vehicleId, setVehicleId] = React.useState(0);
  const [showMoreOCR, setShowMoreOCR] = React.useState(false);

  React.useEffect(() => {
    if (lpr) {
      setLicensePlate(lpr.length > 0 ? lpr[0].text : "");
    }
    if (ocr.vehicleIds) {
      setVehicleId(0);
    }
  }, [lpr, ocr]);

  const renderFr = () => {
    return (
      <>
        <Box className={classes.recognitionTitle}>
          {I18n.get("site_capturedPhotos")}
        </Box>
        <Grid container>
          {fr && fr.length > 0 ? (
            fr.map((rec, index) => (
              <CapturedPhoto
                key={index + "context"}
                type=""
                img={rec.img}
                values={[]}
                matched={false}
              />
            ))
          ) : (
            <Grid item>{I18n.get("site_noPhotoFound")}</Grid>
          )}
        </Grid>
      </>
    );
  };

  const renderLPR = () => {
    return (
      <Grid container>
        <Grid item xs={5} className={classes.optionsContainer}>
          <RadioGroup
            name="licensePlate"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
          >
            {lpr && lpr.length > 0
              ? lpr.map((lp, index) => (
                  <FormControlLabel
                    key={index}
                    value={lp.text}
                    control={<Radio color="primary" />}
                    label={
                      lp.text + " (" + parseInt(lp.confidenceIndex * 100) + "%)"
                    }
                    classes={{ label: "text-54" }}
                    className={classes.option}
                  />
                ))
              : I18n.get("site_noLPR")}
          </RadioGroup>
        </Grid>
        {lpr && lpr.length > 0 && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_context")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={lpr[0].contextImage} alt="context_image" />
            </Box>
          </Grid>
        )}
        {licensePlate && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_cropped")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={licensePlate.croppedImage} alt="cropped_image" />
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderOCR = () => {
    return (
      <Grid container>
        <Grid item xs={5} className={classes.optionsContainer}>
          <List>
            {ocr &&
              ocr.slice(0, showMoreOCR ? ocr.length : 3).map((vi, index) => (
                <ListItem key={index} onClick={() => setVehicleId(index)}>
                  {index === vehicleId && (
                    <ListItemIcon classes={{ root: classes.rootIcon }}>
                      <img src={images.eyeIcon} alt="eye" />
                    </ListItemIcon>
                  )}
                  <ListItemText
                    inset={index !== vehicleId}
                    classes={{
                      root: classes.viewMore,
                      inset: classes.insetItem,
                    }}
                    primary={
                      vi.text + " (" + parseInt(vi.confidenceIndex * 100) + "%)"
                    }
                  />
                </ListItem>
              ))}
            {ocr && ocr.length > 3 && (
              <ListItem>
                <ListItemText
                  inset
                  primary={
                    showMoreOCR
                      ? I18n.get("site_viewLess")
                      : I18n.get("site_view") +
                        " " +
                        (ocr.length - 3) +
                        " " +
                        I18n.get("site_more")
                  }
                  onClick={() => setShowMoreOCR(!showMoreOCR)}
                  classes={{
                    root: classes.viewMore,
                    inset: classes.insetItem,
                  }}
                />
              </ListItem>
            )}
            {ocr && ocr.length === 0 && I18n.get("site_noOCR")}
          </List>
        </Grid>
        {ocr[vehicleId] && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_context")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={ocr[vehicleId].contextImage} alt="context_image" />
            </Box>
          </Grid>
        )}
        {ocr[vehicleId] && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_cropped")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={ocr[vehicleId].croppedImage} alt="cropped_image" />
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <Box>
      <Grid container direction="row-reverse" className={classes.titleBar}>
        <Grid item xs={2} className={classes.closeBtn}>
          <CloseIcon closeFunction={props.close} />
        </Grid>
        <Grid item xs={8} className="text-87 text-center">
          {I18n.get("site_" + type).toUpperCase() +
            " - " +
            I18n.get("site_details").toUpperCase()}
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          style={{ maxWidth: "1000px", minWidth: "500px", margin: "auto" }}
        >
          {type === driver && renderFr()}
        </Grid>
      </Grid>

      {type !== driver && (
        <Grid container justify="center">
          <Grid item xs={6} lg={5} xl={4} className={classes.block}>
            <Box className={classes.recognitionTitle}>
              {I18n.get("site_licensePlateRecognition")}
            </Box>
            {Object.keys(lpr).length > 0 ? renderLPR() : I18n.get("site_noLPR")}
          </Grid>
          <Grid item xs={6} lg={5} xl={4} className={classes.block}>
            <Box className={classes.recognitionTitle}>
              {I18n.get("site_opticalCharacterRecognition")}
            </Box>
            {Object.keys(ocr).length > 0 ? renderOCR() : I18n.get("site_noOCR")}
          </Grid>
        </Grid>
      )}
      <Box className={classes.btnGroup}>
        <Button color="primary" onClick={props.close}>
          {I18n.get("site_close")}
        </Button>
        {/*<CreateProfileDialog
          disabled={true}
          type={type}
          fr={fr}
          ocr={ocr}
          lpr={lpr}
        />*/}
      </Box>
    </Box>
  );
};

DetectionDetails.propTypes = {
  fr: PropTypes.array,
  ocr: PropTypes.array,
  lpr: PropTypes.array,
};

export default withStyles(styles)(DetectionDetails);
